// extracted by mini-css-extract-plugin
export default {"Products":"styles_Products__VKTHE","ImgProduct":"styles_ImgProduct__1T4Ox","ProductName":"styles_ProductName__2GUiF","ProducerName":"styles_ProducerName__tnJgJ"};